import { URL_BASE_TAREAS_OP } from "../../constants/url";
import { get, post } from "../../utils/fetch";

export const startGetTareasOp = (ordenPagoID) => async (dispatch) => {
    const result = await get(`${URL_BASE_TAREAS_OP}/ListaPorOp/${ordenPagoID}`)
    if (result.code === 0 ) {
        return { success: true, data: result.data}
    } else {
        return { success: false, error: result.error}
    }
}

export const startTerminarTarea = (tareaOpID) => async (dispatch) => {
    const result = await post(`${URL_BASE_TAREAS_OP}/TerminarTarea`, { tareaOpID })
    if (result.code === 0) {
        return { success: true }
    } else {
        return { success: false, error: result.error }
    }
}

export const startGetUsuariosTareas = () => async (dispatch) => {
    const result = await get(`${URL_BASE_TAREAS_OP}/ListaUsuarios`)
    if (result.code === 0) {
        return { success: true, data: result.data }
    } else {
        return { success: false, error: result.error }
    }
}

export const startCrearTarea = (body) => async (dispatch) => {
    const result = await post(`${URL_BASE_TAREAS_OP}/CrearTarea`, body)
    if (result.code === 0) {
        return { success: true}
    } else {
        return { success: false, error: result.error }
    }
}